import { useMemo } from "react";
import { useAuth } from "../../app/auth/useAuth";
import { useI18n } from "../../app/i18n/useI18n";
import { NavCardGrid,type NavCardGroup,type NavCardItem } from "../../components/NavCardGrid";
import { areaAccessContextFromAuth } from "../../app/navigation/areaCatalog";
import { hasToolsItemPermission, toolsCatalogGroups } from "./toolsCatalog";

export function ToolsHomePage() {
  const auth = useAuth();
  const { tr, text } = useI18n();

  const groups = useMemo((): NavCardGroup[] => {
    const ctx = areaAccessContextFromAuth(auth.info);
    return toolsCatalogGroups
      .map((g) => ({
        title: g.title,
        titleKey: g.titleKey ?? g.title,
        items: (g.items || [])
          // Nicht freigeschaltete Module erscheinen gesperrt (capabilityKey), nicht unsichtbar.
          .filter((item) => hasToolsItemPermission(item, ctx))
          .map<NavCardItem>((item) => ({
            titleKey: item.titleKey ?? item.title,
            descriptionKey: item.descriptionKey ?? item.description,
            iconKey: item.iconKey,
            path: item.path,
            capabilityKey: item.requiredCapability
          }))
      }))
      .filter((g) => (g.items || []).length > 0);
  }, [auth]);

  // Nur eine sichtbare Gruppe → flach rendern, keine Gruppen-Überschrift (Divider).
  // Seiten-Überschrift "Werkzeuge" wird in jedem Fall gerendert.
  return (
    <NavCardGrid title={tr("Tools")} items={groups.length === 1 ? groups[0].items : undefined}
      groups={groups.length === 1 ? undefined : groups} text={text} />
  );
}
